import React from "react";
import { Container } from "reactstrap";
import styled from "styled-components";
import { AuthenticatedRoutes } from "./AuthenticatedRoutes";
import HeaderMessages from "./HeaderMessages";
import { Menu } from "src/app/layout/Menu";
import Popups from "src/app/popups/Popups";
import { SuspendedMerchantPopup } from "src/app/ui/authenticated/SuspendedMerchantPopup";
import { ChatMessagesContext } from "src/chats/contexts/ChatMessagesContext";
import { useChatMessagesControl } from "src/chats/hooks/useChatMessagesControl.hooks";

export const MainUI = () => {
  const chatMessagesControl = useChatMessagesControl();
  return (
    <ChatMessagesContext.Provider value={chatMessagesControl}>
      <MainContainer>
        <div className="raange-menu">
          <Menu />
        </div>
        <ContentContainer fluid>
          <HeaderMessages />

          <AuthenticatedRoutes />

          <SuspendedMerchantPopup />

          <Popups />
        </ContentContainer>
      </MainContainer>
    </ChatMessagesContext.Provider>
  );
};

const MainContainer = styled.div`
  padding-top: 56px;
  height: 100%;
  width: 100%;
`;

const ContentContainer = styled(Container)`
  height: 100%;
  margin: 1em 0;
`;
